<template>
  <main class="wrapper-content w-100">
    <LmComponentLoading v-if="loading" fixed />

    <h1>Codificadores Builder</h1>

    <LmForm ref="lmFormRef" >
      <portal-target name="destination-after-title" slim/>
      <LmCheckbox
        class="col-12 pl-0"
        v-model="formData.isChild"
        labelSingle="Es un Codificador Builder hijo"
      />
      <LmTreeSelect
        v-if="formData.isChild"
        label="Codificadores Builder Padre"
        :pathToGetOptions="'/codificatorbuilder/parents/all'"
        v-model="formData.parentCodificatorBuilder"
      />
      <LmTextInput
        class="col-12 px-0"
        :v="$v.formData.codificatorName"
        v-model="formData.codificatorName"
        label="Nombre del codificator builder"
        placeholder="Nombre"
      />
      <LmImportFromExcel
        class="col-12 px-0 mb-4"
        label="Importa codificadores desde un excel"
        placeholder="Carga tu archivo aqui..."
        pathForPostRequest="/codificator/"
        :availableFields="availableFieldsForExcelImport"
        :customParams="customParamsForExcelImport"
        v-if="isOnEditMode"
      />
    </LmForm>
    <LmCheckbox
      class="col-12 px-0"
      labelSingle="Es un codificador builder interno"
      v-model="formData.lumbreInternal"
      v-if="userRole === 'Superusuario'"
    />
    <LmUserPermissions
      class="col-6 px-0"
      v-model="form.softPermissions"
      :settings="softPermissionsSettings"
    />
      <!-- FormBuilderUi -->
    <div id="lm-form-builder-ui" class="wrapper-content w-100 pl-0 mt-3">
      <h3>Propiedades personalizadas</h3>
      <div class="row position-relative">
        <div class="col-12 col-md-6">
          <LmForm ref="lmFormBuilderRef" id="form-builder-ui-form">
            <draggable
              class="col-12 px-0"
              v-model="form.formElements"
              @start="drag=true"
              @end="drag=false"
              animation="150"
              handle=".handle"
              >
              <div v-for="(formElement, index) in form.formElements" :key="formElement.id" class="mt-4">
                <header
                  class="d-flex justify-content-between align-items-center bg-primary text-white px-3 handle shadow rounded-lg"
                  :class="{'bg-info': !shouldCreatePortal(form.formElements[index].componentName)}">
                  <font-awesome-icon class="mr-4" icon="arrows-alt" style="width:18px; height:18px;" />
                  <h4 v-b-toggle="`collapse-${index}`" class="flex-grow-1 text-center my-0 py-3 handle">{{title(form.formElements[index])}}</h4>
                  <div v-if="shouldCreatePortal(form.formElements[index].componentName)" class="circle d-flex justify-content-center align-items-center">{{index}}</div>
                  <div class="d-flex align-items-center">
                    <font-awesome-icon v-b-toggle="`collapse-${index}`" class="ml-4 clickable" icon="chevron-down" style="width:16px; height:16px;" />
                    <font-awesome-icon class="ml-4 clickable" icon="trash" style="width:16px; height:16px;" @click="removeFormElement(index)" />
                  </div>
                </header>
                <b-collapse
                  accordion="my-accordion"
                  :id="`collapse-${index}`"
                  visible
                  class="p-4 border border-top-0 rounded-lg"
                  >
                  <LmSelect
                    :id="'select-elements-' + index"
                    v-model="form.formElements[index].componentName"
                    :options="componentsOptions"
                    label="Seleccione el tipo de elemento"
                    @input="selectorElementForm($event, index)"
                  />
                  <component
                    :index="index"
                    :is="whatComponentBuilderUse(form.formElements[index].componentName)"
                    :id="form.formElements[index].formObjectToSendToServerProperty || form.formElements[index].id"
                    :componentData="form.formElements[index]"
                    :optionsChildOf="buildOptionsChildOf(form.formElements[index].formObjectToSendToServerProperty)"
                    :leftValueToCompareOptions="leftValueToCompareOptions(form.formElements[index])"
                    :visibilityDependOnConditions="form.formElements[index].visibilityDependOnConditions"
                    :optionsSameAsValidation="{content: buildSameAsOptions(form.formElements)}"
                    :validationsData="getValidation(form.formElements[index].formObjectToSendToServerProperty)"
                    :options="lmSuperPowerSelectV2BuilderUiOptions"
                    :isOnEditMode="isOnEditMode"
                    @input="inputHandler($event, index)"
                    @validations-changes="validationsChangesHandler"
                  />
                </b-collapse>
              </div>
            </draggable>
            <div class="col-12 pl-0">
              <LmButton
                id="add-field-button"
                class="mt-4"
                type="button"
                lmButtonRootWrapperClass="d-inline-block"
                lmButtonWrapperClass="col"
                @click.native="addFormElement(form.formElements.length)"
                value="Agregar un campo al formulario"
              />
            </div>
          </LmForm>
        </div>
      </div>
    </div>
    <!-- FormBuilderUi -->
    <div class="d-flex wrapper-content pl-0">
      <LmButton
        :value="$t('cancel')"
        class="col-auto pl-0"
        type="button"
        buttonClass="btn-secondary"
        @click="onCancel()"
      />
      <LmButton
        :disabled="isDisabledByUserPrivileges()"
        :value="$t('save')"
        class="col-auto"
        buttonClass="btn-primary"
        type="button"
        @click="onSubmit()"
      />
      <LmButton
        v-if="isOnEditMode"
        :disabled="isDisabledByUserPrivileges('delete')"
        class="col-auto"
        buttonClass="btn-danger"
        :value="$t('delete')"
        action="delete"
        @click="onDelete()"
      />
    </div>
    <p
      v-if="isDisabledByUserPrivileges()"
      class="font-italic text-danger"
    >
      Lo sentimos, no tiene permisos para guardar los cambios.
    </p>
  </main>
</template>

<script>
// Components
import LmForm from '@/components/form/LmForm'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import LmSelect from '@/components/form/elements/LmSelect'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmImportFromExcel from '@/components/form/elements/LmImportFromExcel'
import LmUserPermissions from '@/components/LmUserPermissions'

// FormBuilder Components
import LmTextNumberEditorTextAreaPasswordBuilderUi from '@/components/lmFormBuilderUi/LmTextNumberEditorTextAreaPasswordBuilderUi'
import LmEmailInputBuilderUi from '@/components/lmFormBuilderUi/LmEmailInputBuilderUi'
import LmFormSubtitlesBuilderUi from '@/components/lmFormBuilderUi/LmFormSubtitlesBuilderUi'
import LmFormEmptySpaceBuilderUi from '@/components/lmFormBuilderUi/LmFormEmptySpaceBuilderUi'
import LmFormSeparatorBuilderUi from '@/components/lmFormBuilderUi/LmFormSeparatorBuilderUi'
import LmSelectBuilderUi from '@/components/lmFormBuilderUi/LmSelectBuilderUi'
import LmSuperPowerSelectV2BuilderUi from '@/components/lmFormBuilderUi/LmSuperPowerSelectV2BuilderUi'
import LmButtonBuilderUi from '@/components/lmFormBuilderUi/LmButtonBuilderUi'
import LmDateBuilderUi from '@/components/lmFormBuilderUi/LmDateBuilderUi'
import LmDateTimeBuilderUi from '@/components/lmFormBuilderUi/LmDateTimeBuilderUi'
import LmLeaFletMapBuilderUi from '@/components/lmFormBuilderUi/LmLeaFletMapBuilderUi'
import LmHtmlContentBuilderUi from '@/components/lmFormBuilderUi/LmHtmlContentBuilderUi'
import LmFormPortalBuilderUi from '@/components/lmFormBuilderUi/LmFormPortalBuilderUi'
import LmColorPickerBuilderUi from '@/components/lmFormBuilderUi/LmColorPickerBuilderUi'
import LmCommentBuilderUi from '@/components/lmFormBuilderUi/LmCommentBuilderUi'
import LmRepeatFieldsBuilderUi from '@/components/lmFormBuilderUi/LmRepeatFieldsBuilderUi'
import LmCheckboxBuilderUi from '@/components/lmFormBuilderUi/LmCheckboxBuilderUi'
import LmUploadFilesBuilderUi from '@/components/lmFormBuilderUi/LmUploadFilesBuilderUi'
import LmImportFromExcelBuilderUi from '@/components/lmFormBuilderUi/LmImportFromExcelBuilderUi'
import LmCustomBuilderUi from '@/components/lmFormBuilderUi/LmCustomBuilderUi'
import LmSignersBuilderUi from '@/components/lmFormBuilderUi/LmSignersBuilderUi'
import LmRadioBuilderUi from '@/components/lmFormBuilderUi/LmRadioBuilderUi'
import LmCodeInputBuilderUi from '@/components/lmFormBuilderUi/LmCodeInputBuilderUi'
import LmTreeSelectBuilderUi from '@/components/lmFormBuilderUi/LmTreeSelectBuilderUi'

// Utils
import draggable from 'vuedraggable'
import VueScrollTo from 'vue-scrollto'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import lmFormBuilderUi from '@/mixins/lmFormBuilderUi.js'
import { checkSoftPermissions, getCurrentUserRole } from '@/helpers/LmUserPermissions'
import {
  required
} from 'vuelidate/lib/validators'

export default {
  components: {
    LmForm,
    LmSuperPowerSelectV2,
    LmTreeSelect,
    LmTextInput,
    LmCheckbox,
    LmButton,
    LmSelect,
    LmImportFromExcel,
    LmTextNumberEditorTextAreaPasswordBuilderUi,
    LmEmailInputBuilderUi,
    LmFormSubtitlesBuilderUi,
    LmFormEmptySpaceBuilderUi,
    LmFormSeparatorBuilderUi,
    LmSelectBuilderUi,
    LmSuperPowerSelectV2BuilderUi,
    LmButtonBuilderUi,
    LmDateBuilderUi,
    LmDateTimeBuilderUi,
    LmLeaFletMapBuilderUi,
    LmHtmlContentBuilderUi,
    LmFormPortalBuilderUi,
    LmColorPickerBuilderUi,
    draggable,
    LmCommentBuilderUi,
    LmRepeatFieldsBuilderUi,
    LmCheckboxBuilderUi,
    LmUploadFilesBuilderUi,
    LmUserPermissions,
    LmImportFromExcelBuilderUi,
    LmCustomBuilderUi,
    LmSignersBuilderUi,
    LmRadioBuilderUi,
    LmCodeInputBuilderUi,
    LmTreeSelectBuilderUi
  },
  mixins: [lmToasts, lmFormBuilderUi],
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formData: {
        codificatorName: '',
        isChild: false,
        parentCodificatorBuilder: null,
        lumbreInternal: false
      },
      form: {
        validations: {},
        formElements: [],
        softPermissions: {
          allowAccess: [],
          allowUpdate: [],
          allowDelete: [],
          allowCreateContent: [],
          allowUpdateContent: [],
          allowDeleteContent: []
        }
      },
      softPermissionsSettings: {
        allowAccess: {
          default: ['ADMINISTRARCODIFICACIONES'],
          show: false,
          label: 'Permite acceder'
        },
        allowUpdate: {
          default: ['ADMINISTRARCODIFICACIONES'],
          show: false,
          label: 'Permite actualizar'
        },
        allowDelete: {
          default: ['ADMINISTRARCODIFICACIONES'],
          show: false,
          label: 'Permite eliminar'
        },
        allowCreateContent: {
          default: ['ADMINISTRACODIFICADORESSECUNDARIOS'],
          label: 'Permite crear codificadores'
        },
        allowUpdateContent: {
          default: ['ADMINISTRACODIFICADORESSECUNDARIOS'],
          label: 'Permite actualizar codificadores'
        },
        allowDeleteContent: {
          default: ['ADMINISTRACODIFICADORESSECUNDARIOS'],
          label: 'Permite eliminar codificadores'
        }
      },
      initialForm: {},
      loading: false,
      viewPermissions: {
        allowAccess: process?.env?.VUE_APP_FORM_CODIFICATORBUILDER_ALLOW_PERMISSIONS?.split(',') || [],
        allowCreateContent: process?.env?.VUE_APP_FORM_CODIFICATORBUILDER_CREATE_PERMISSIONS?.split(',') || [],
        allowUpdateContent: process?.env?.VUE_APP_FORM_CODIFICATORBUILDER_UPDATE_PERMISSIONS?.split(',') || [],
        allowDeleteContent: process?.env?.VUE_APP_FORM_CODIFICATORBUILDER_DELETE_PERMISSIONS?.split(',') || []
      },
      userPrivileges: {},
      userRole: getCurrentUserRole()
    }
  },
  validations: {
    formData: {
      codificatorName: {
        required
      }
    }
  },
  computed: {
    customParamsForExcelImport () {
      const params = []
      params.push({
        property: 'codificatorBuilderId',
        value: this.$route.params.id
      })
      if (this.formData.isChild) {
        params.push({
          property: 'parentCodificatorBuilder',
          value: this.formData.parentCodificatorBuilder
        })
      }
      return params
    },
    availableFieldsForExcelImport () {
      const obj = this.form.formElements.map(el => el.formObjectToSendToServerProperty)
      obj.push('name')
      return obj
    }
  },
  methods: {
    updateForm (formDataFromLmFormBuilder) {
      for (const key in formDataFromLmFormBuilder) {
        this.formData[key] = formDataFromLmFormBuilder[key]
      }
    },
    async onSubmit () {
      try {
        this.loading = true

        const codificatorbuilderData = {
          ...this.formData,
          formBuilderCustomFields: [...this.form.formElements],
          customFieldsValidations: this.form.validations,
          softPermissions: this.form.softPermissions
        }

        // Validaciones
        await this.validationForm(this.$v, false)

        if (this.isOnEditMode) {
          const r = await commonsApi.axiosPutWrapper(`/codificatorbuilder/${this.$route.params.id}`, codificatorbuilderData)
          this.lmToastSuccessMessage(`Se editó ${r?.data?.codificatorName || ' el codificador'} correctamente.`, 'Se guardó exitosamente')
        } else {
          const r = await commonsApi.axiosPostWrapper(`/codificatorbuilder/`, codificatorbuilderData)
          this.lmToastSuccessMessage(`Se creó ${r?.data?.codificatorName || ' el codificador'} correctamente.`, 'Se guardó exitosamente')
        }
        setTimeout(() => {
          this.$router.push(process.env.VUE_APP_CODIFICATOR_BUILDER_LISTBUILDER_PATH || '/listbuilder/view/60c0d82900088a3870b3f9de')
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async onDelete () {
      try {
        this.loading = true
        if (this.isOnEditMode) {
          const r = await commonsApi.axiosPutWrapper(`/codificatorbuilder/delete/${this.$route.params.id}`)
          this.lmToastSuccessMessage(`Se eliminó ${r?.data?.codificatorName || ' el codificador'} correctamente.`, 'Se eliminó exitosamente')
          setTimeout(() => {
            this.$router.push(process.env.VUE_APP_CODIFICATOR_BUILDER_LISTBUILDER_PATH || '/listbuilder/view/60c0d82900088a3870b3f9de')
          }, 650)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    onCancel () {
      this.$router.push(process.env.VUE_APP_CODIFICATOR_BUILDER_LISTBUILDER_PATH || '/listbuilder/view/60c0d82900088a3870b3f9de')
    },
    leftValueToCompareOptions (formElementToExclude) {
      return {
        disabledOption: this.$t('Element'),
        content: this.form.formElements.filter(e => e.hasOwnProperty('formObjectToSendToServerProperty')).filter(e => e.id !== formElementToExclude.id).map(e => ({ value: e.formObjectToSendToServerProperty, text: e.componentProps.label }))
      }
    },
    shouldCreatePortal (componentName) {
      return componentName !== 'LmComment'
    },
    openEditFormElement (index) {
      this.$root.$emit('bv::toggle::collapse', `collapse-${index}`)
    },
    title (component) {
      if (this.componentsOptions?.content?.length) {
        const componentLabel = component?.componentProps?.label
        const componentValue = component?.componentProps?.value
        const componentText = component?.componentProps?.text
        const { text } = this.componentsOptions.content.find(e => e.value === component?.componentName)
        let moreInfo = ''
        if (componentLabel) {
          moreInfo += ' - ' + componentLabel
        } else if (componentValue) {
          moreInfo += ' - ' + componentValue
        } else if (componentText) {
          moreInfo += ' - ' + componentText
        }
        return text + moreInfo
      } else {
        return ''
      }
    },
    addFormElement (elementIndex) {
      this.selectorElementForm('LmTextInput', elementIndex)
    },
    inputHandler (event, index) {
      this.form.formElements[index] = event
    },
    validationsChangesHandler (payload) {
      let newValidation = {}
      const formValidationHasItem = Object.keys(this.form.validations).length
      if (formValidationHasItem) {
        for (const validation in this.form.validations) {
          const existFormObjectToSendToServerPropertyForValidation = this.form.formElements.find((el) => el.formObjectToSendToServerProperty === validation)
          if (existFormObjectToSendToServerPropertyForValidation) {
            newValidation = { ...newValidation, [validation]: this.form.validations[validation] }
          }
        }
        this.form.validations = { ...newValidation, ...payload }
      } else {
        this.form.validations = { ...this.form.validations, ...payload }
      }
    },
    showToastFormError (msg = this.$t('form_with_errors')) {
      this.$bvToast.toast(msg, {
        title: 'Error',
        toaster: 'b-toaster-bottom-center',
        variant: 'danger',
        solid: true
      })
    },
    errorScrollTo () {
      VueScrollTo.scrollTo(this.id, 1000, { offset: -60 })
    },
    validationForm (validation, mustShowToat = true) {
      validation.$touch()
      if (validation.$error) {
        if (mustShowToat) {
          this.showToastFormError()
        }
        this.errorScrollTo()
        return Promise.reject(new Error('validation error'))
      } else {
        if (!validation.$pending || !validation.$error) {
          return Promise.resolve(true)
        } else {
          Promise.reject(new Error('validation error'))
        }
      }
    },
    isDisabledByUserPrivileges (btnType = 'save') {
      if (this.userRole !== 'Superusuario') {
        // Crear
        if (!this.userPrivileges.allowCreateContent && !this.isOnEditMode) {
          return true
        }
        // Actualizar
        if (!this.userPrivileges.allowUpdateContent && this.isOnEditMode) {
          return true
        }
        // Eliminar
        if (!this.userPrivileges.allowDeleteContent && this.isOnEditMode && btnType === 'delete') {
          return true
        }
      }
      return false
    }
  },
  async created () {
    // Check user permissions
    this.userPrivileges = checkSoftPermissions(this.viewPermissions)
    if (!this.userPrivileges.allowAccess && this.userRole !== 'Superusuario') {
      this.lmToastDangerMessage('Lo sentimos, no tiene permisos para realizar esta acción.', 'Error al acceder')
      this.$router.push('/')
    }

    try {
      this.loading = true
      this.initialForm = JSON.stringify(this.form)

      if (this.isOnEditMode) {
        const { data } = await commonsApi.axiosGetWrapper(`codificatorbuilder/${this.$route.params.id}`)
        this.formData = {
          codificatorName: data.codificatorName,
          isChild: data.isChild,
          parentCodificatorBuilder: data.parentCodificatorBuilder
        }
        this.form.formElements = data?.formBuilderCustomFields || []
        this.form.validations = data?.customFieldsValidations || {}

        if (data?.softPermissions) {
          for (const key in data.softPermissions) {
            this.form.softPermissions[key] = data.softPermissions[key]
          }
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.loading = false
    }
  }
}
</script>

<style lang="sass" scoped>
.circle
  background: white
  color: black
  border-radius: 50%
  width: 25px
  height: 25px
  text-align: center
</style>
